<input
    id="url"
    class="form-control form-control-sm"
    [formControl]="urlController"
/>
<select class="form-control" [formControl]="targetController">
    <option value="_blank">New tab</option>
    <option value="_self">Current tab</option>
</select>
